import Stack from '@mui/material/Stack';

import { ensureDefined } from '@e-socna/utils';

import { Loading } from '../../../../components/Loading';
import { NoData } from '../../../../components/Illustrations/NoData';
import { useFindAllCostsQuery } from '../../../../components/CostList/hooks/useFindAllCostsQuery.hook';
import { useContextualizedFields } from '../../../../hooks/useContextualizedFields.hook';

import type { CostUsageForm_CostUsage } from '../../fragments/cost-usage.fragment';

import { Item } from './Item';

interface Props {
  readonly formContext?: string;
  readonly id: string;
}

export const CostsUsageFormStep = ({ formContext }: Readonly<Props>) => {
  const { data, isSuccess } = useFindAllCostsQuery();

  const fields = useContextualizedFields<
    Readonly<{
      costUsages: readonly CostUsageForm_CostUsage[] | undefined;
    }>
  >(
    {
      costUsages: {
        id: 'cost-usages',
        name: 'costUsages',
      },
    },
    formContext,
  );

  const { costUsages } = ensureDefined({
    costUsages: fields.costUsages.value,
  });

  if (!costUsages.length) {
    return <NoData />;
  }

  if (!isSuccess) {
    return <Loading />;
  }

  const allCosts = data.findAllCosts;

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      {costUsages.map((costUsage, index) => (
        <Item
          allCosts={allCosts}
          costUsage={costUsage}
          formContext={formContext}
          index={index}
          key={costUsage._id}
        />
      ))}
    </Stack>
  );
};
